<template>
  <div>
    <div class="c-AllocationCarEntry__info" style="display: none;">
      <div>車両情報</div>
      <div class="c-AllocationCarEntry__itemsWrap">
        <div class="c-AllocationBicycleEntry__vehicleInfo">
          <label for="name" class="c-AllocationBicycleEntry__vehicleInfo__label"
            >自転車種類</label
          >
          <div class="c-AllocationBicycleEntry__vehicleInfo__InputWrap">
            <div class="c-AllocationBicycleEntry__vehicleInfo__Input">
              <input
                type="radio"
                id="one"
                value="普通"
                v-model="$v.entry.spec.type.$model"
              />
              <label for="one">普通</label>
            </div>
            <div class="c-AllocationBicycleEntry__vehicleInfo__Input">
              <input
                type="radio"
                id="two"
                value="電動アシスト"
                v-model="$v.entry.spec.type.$model"
              />
              <label for="two">電動アシスト</label>
            </div>
          </div>
        </div>
        <div class="c-AllocationBicycleEntry__vehicleInfo">
          <label for="name" class="c-AllocationBicycleEntry__vehicleInfo__label"
            >チャイルドシート
          </label>
          <div class="c-AllocationBicycleEntry__vehicleInfo__InputWrap">
            <div class="c-AllocationBicycleEntry__vehicleInfo__Input">
              <input
                type="radio"
                id="c1"
                value="1"
                v-model="$v.entry.spec.childSheet.$model"
              />
              <label for="c1">あり</label>
            </div>
            <div class="c-AllocationBicycleEntry__vehicleInfo__Input">
              <input
                type="radio"
                id="c2"
                value="0"
                v-model="$v.entry.spec.childSheet.$model"
              />
              <label for="c2">なし</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div style="font-size:1.4rem;">希望順位</div>
    <div class="c-allocation-tableWrap">
      <table class="c-allocation-table">
        <tr>
          <th>順位</th>
          <th>ブロック</th>
          <th>種別</th>
          <th>番号</th>
          <th>全長<br />(mm)</th>
          <th>全幅<br />(mm)</th>
          <th>全高<br />(mm)</th>
          <th>車両重量<br />(kg)</th>
          <th>税込み月額料金<br />（月額／円）</th>
          <th>台数</th>
        </tr>
        <tr v-for="(block, key) in blocks" :key="key">
          <td>
            <label>
              <select
                @change="onChangeOrder(key)"
                v-model="$v.entry.entries[key].$model"
                :disabled="entry.entries[key] == 999999"
                style="width: 8rem;"
              >
                <option
                  disabled
                  value="999999"
                  v-if="entry.entries[key] == 999999"
                >
                  選択不可
                </option>
                <option disabled value="">選択してください</option>
                <option
                  v-for="order in orders"
                  :key="order.value"
                  :value="order.value"
                >
                  {{ order.label }}
                </option>
              </select>
            </label>
            <div class="error" v-if="!$v.entry.entries[key].required">
              必須です
            </div>
          </td>
          <td>{{ key }}</td>
          <td>{{ block.type }}</td>
          <td>{{ block.no.join(",") }}</td>
          <td>{{ block.length }}</td>
          <td>{{ block.width }}</td>
          <td>{{ block.height }}</td>
          <td>{{ block.weight }}</td>
          <td>{{ block.fee.toLocaleString() }}</td>
          <td>{{ block.number }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { required, integer } from "vuelidate/lib/validators";
// import AllocationService from "../services/allocation.service";
import AllocationAreaService from "../services/allocation-area.service";
import _ from "lodash";

const enumType = value => {
  return ["普通", "電動アシスト"].includes(value);
};
export default {
  name: "AllocationBicycleEntry",
  props: {
    allocation: {
      type: Object,
      required: true,
    },
    entry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // allocation: {},
      areas: [],
      blocks: {},
      // entry: {
      //   spec: {
      //     name: "",
      //     length: 0,
      //     width: 0,
      //     height: 0,
      //     weight: 0,
      //     own: "購入予定",
      //   },
      //   entries: {},
      // },
      orders: [],
    };
  },
  validations() {
    console.log("Validations working");
    console.log(this.blocks);
    let entries = {};
    for (let key in this.blocks) {
      entries[key] = {
        required,
      };
    }
    return {
      entry: {
        spec: {
          type: {
            required,
            enumType,
          },
          childSheet: {
            required,
            integer,
          },
        },
        entries,
      },
    };
  },
  watch: {
    "entry.entries": {
      // immediate: true,
      handler: function(val, oldVal) {
        console.log("Watcher working"); //Does not fire when parent mutates innerKeys
        console.log(val, oldVal);
        this.checkInvalid();
      },
      deep: true,
    },
    "entry.spec": {
      handler: function(spec) {
        console.log("entry.spec:Watcher working");
        console.log(spec);
        // this.updateSpec();
        this.checkInvalid();
      },
      deep: true,
    },
  },

  async mounted() {
    console.log("Entry mounted.");
    console.log(this.entry);
    await this.$nextTick();
    // await this.loadAllocation();
    await this.loadAllocationArea();
    this.initOrders();
    if (Object.keys(this.entry.entries) == 0) {
      for (const key in this.blocks) {
        if (Object.hasOwnProperty.call(this.blocks, key)) {
          // this.entry.entries[key] = "";
          this.$set(this.entry.entries, key, "");
        }
      }
    }
  },
  methods: {
    checkInvalid() {
      console.log("checkInvalid");
      this.$v.$touch();
      this.$emit("invalid", this.$v.$invalid);
    },
    onBack() {
      this.$router.go(-1);
    },
    onNext() {
      console.log("onNext");
    },
    onAdd() {
      console.log("onAdd");
    },
    onDelete() {
      console.log("onAdd");
    },
    updateSpec() {
      console.log("updateSpec");
      // this.spec = spec;
      console.log(this.entry.spec);
      console.log(this.blocks);
      for (const key in this.blocks) {
        if (Object.hasOwnProperty.call(this.blocks, key)) {
          const block = this.blocks[key];
          if (
            this.entry.spec.length <= block.length &&
            this.entry.spec.width <= block.width &&
            this.entry.spec.height <= block.height &&
            this.entry.spec.weight <= block.weight
          ) {
            // this.$set(this.entry.entries, key, "");
            if (this.entry.entries[key] == 999999) {
              this.entry.entries[key] = "";
            }
          } else {
            this.entry.entries[key] = 999999;
          }
        }
      }
      console.log(this.entry);
    },
    onChangeOrder(selectedKey) {
      console.log("onChangeOrder");
      console.log("selectedKey", selectedKey);
      const value = this.entry.entries[selectedKey];
      console.log("value", value);
      const srcEntries = _.cloneDeep(this.entry.entries);
      console.log("srcEntries", srcEntries);
      let allKeys = Object.keys(this.entry.entries).sort(function(a, b) {
        return srcEntries[a] - srcEntries[b];
      });
      let sortkeys = allKeys.filter(
        key =>
          key != selectedKey &&
          srcEntries[key] != 999999 &&
          srcEntries[key] != 99999 &&
          srcEntries[key] != "",
      );
      console.log("sortkeys", sortkeys);

      if (value > 0) {
        let counter = 1;
        for (let index = 0; index < sortkeys.length; index++) {
          if (counter == value) {
            counter++;
          }
          const key = sortkeys[index];
          if (key != selectedKey) {
            this.entry.entries[key] = counter;
          }
          counter++;
        }
      }

      const destEntries = _.cloneDeep(this.entry.entries);
      console.log("destEntries1", destEntries);

      allKeys = Object.keys(destEntries).sort(function(a, b) {
        return destEntries[a] - destEntries[b];
      });
      sortkeys = allKeys.filter(
        key =>
          srcEntries[key] != 999999 &&
          srcEntries[key] != 99999 &&
          srcEntries[key] != "",
      );
      console.log("sortkeys2", sortkeys);

      let counter = 1;
      for (let index = 0; index < sortkeys.length; index++) {
        let key = sortkeys[index];
        this.entry.entries[key] = counter;

        counter++;
      }

      console.log("destEntries2", this.entry.entries);
    },
    initOrders() {
      this.orders = [{ label: "不要", value: 99999 }];
      let counter = 1;
      for (const key in this.blocks) {
        if (Object.hasOwnProperty.call(this.blocks, key)) {
          // const block = this.blocks[key];
          this.orders.push({
            label: counter,
            value: counter,
          });
          counter++;
        }
      }
      console.log("orders", this.orders);
    },
    // async loadAllocation() {
    //   const response = await AllocationService.findByID(this.$route.params.id);
    //   this.allocation = response.data;
    //   console.log(this.allocation);
    // },
    async loadAllocationArea() {
      console.log("loadAllocationArea");
      const response = await AllocationAreaService.find({
        allocation: this.allocation._id,
      });
      this.areas = response.data;
      console.log(this.areas);

      this.blocks = {};
      for (let index = 0; index < this.areas.length; index++) {
        const area = this.areas[index];
        if (this.blocks[area.block] === undefined) {
          this.blocks[area.block] = {
            type: area.type,
            no: [area.no],
            length: area.length,
            width: area.width,
            height: area.height,
            weight: area.weight,
            fee: area.fee,
            number: area.number,
          };
        } else {
          this.blocks[area.block].no.push(area.no);
        }
      }
      console.log("blocks", this.blocks);
    },
  },
};
</script>
